<div class="settings-container">
  <div class="label">Your Profile</div>
  <div class="logo">
    <div class="icon">
      <i class="fa-solid fa-user" *ngIf="!image"></i>
      <img *ngIf="image" [src]="getImage('data:image/jpeg;base64,'+image)" alt="">
    </div>
  </div>
  <div class="add-update-text">
    <input
    type="file"
    id="file-input"
    accept=".jpg, .png, .jpeg"
    (change)="onFileUpload($event)"
    autocomplete="off"
    placeholder="upload a file"
  />
  <label for="file-input">
    <span class="text">Profile picture</span>
    <span class="file-text">{{ fileName }}</span>
  </label>
  </div>
  <div class="update-btn">
    <button (click)="onUpdate()">Update</button>
  </div>
</div>